/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots9Icon64Regular = forwardRef('UiMenuDots9Icon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M50 17.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M17.5 32a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M53.5 32a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M14 53.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M35.5 50a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M53.5 50a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M32 35.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" }),
        React.createElement("path", { d: "M35.5 14a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M14 17.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" })));
});
